import api from '@api/api';
import { EmailTemplate } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useEmailTemplates = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<EmailTemplate>({
    queryKeyRoot: 'email-templates',
    apiFn: (params) => api.getEmailTemplates(params),
    date,
  });

  return { emailTemplates: data, isFetching, error, ...rest };
};

export default useEmailTemplates;
